var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.413 20.579l-4.217-4.217a10.495 10.495 0 10-2.834 2.834l4.226 4.217a2.003 2.003 0 003.26-.65 2.004 2.004 0 00-.435-2.184zM10.484 1.962a8.513 8.513 0 11-8.512 8.513 8.522 8.522 0 018.512-8.513z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.978 11.476H9.48v2.503a1.002 1.002 0 102.004 0v-2.503h2.504a1.002 1.002 0 100-2.003h-2.504V6.969a1.001 1.001 0 10-2.004 0v2.504H6.978a1.002 1.002 0 000 2.003z"
  })));
}
export default SvgZoomIn24;